<template>
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        <div class="overflow-hidden border-b border-gray-200 bg-gray-50 shadow sm:rounded-lg">
          <p
            v-if="projects.data.length === 0"
            class="m-5">
            No Projects to show
          </p>
          <template v-else>
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                    Project
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                    Project Manager
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                    Pax × Budget p.p.
                  </th>
                  <th
                    scope="col"
                    class="hidden px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 md:table-cell">
                    Created
                  </th>
                  <th
                    scope="col"
                    class="hidden px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 md:table-cell">
                    Status
                  </th>
                  <th class="w-2/12 bg-gray-50 px-6 py-3" />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="project in projects.data"
                  class="bg-white">
                  <td class="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                    {{ project.name }}
                  </td>
                  <td class="px-6 py-4 text-sm leading-5 text-gray-500">
                    {{ project.manager.name }}
                  </td>
                  <td class="px-6 py-4 text-sm leading-5 text-gray-500">
                    {{ project.total_travelers }} pax &times; {{ formatCurrency(project.budget_per_traveller) }} p.p.
                  </td>
                  <td class="px-6 py-4 text-sm leading-5 text-gray-500">
                    {{ project.created_at ? getDateTimeInCurrentTimezone(project.created_at, 'DD.MM.YYYY') : '-' }}
                  </td>
                  <td class="whitespace-no-wrap px-6 py-4">
                    <!-- Class list is listed in StatusBadge.vue -->
                    <StatusBadge
                      :class="['basicLarge' ]"
                      :status="project.status" />
                  </td>
                  <td class="whitespace-no-wrap px-6 py-4 text-right text-sm font-medium leading-5">
                    <Link
                      :href="route('projects.show', {id: project.id})"
                      class="text-indigo-600 hover:text-indigo-900">
                      Go to project
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>

            <pagination
              v-if="paginate"
              :model="projects" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import {
  formatCurrency, getDateTimeInCurrentTimezone,
} from '@/utils';
import Pagination from './Pagination.vue';
import StatusBadge from './StatusBadge.vue';

export default {
  name: 'ProjectList',
  components: {
    Pagination,
    StatusBadge,
    Link,
  },

  props: {
    projects: Object,
    paginate: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  methods: {
    getDateTimeInCurrentTimezone,
    formatCurrency,
  },
};
</script>

<style scoped>

</style>
